// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: 'a9a2d218-2c8c-4d31-b16c-c90a0559ae0b',
      type: 'NineSlicePlane',
      runtimeType: null,
      name: '',
      className: '',
      x: -300,
      y: -150,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 600,
      height: 300,
      leftWidth: 20,
      topHeight: 20,
      rightWidth: 20,
      bottomHeight: 20,
      angle: 0,
      alpha: 0.8,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Black_Blur_Square',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '5d661985-f8b7-4acc-a7b7-f45679f8be2a',
      type: 'Text',
      runtimeType: null,
      name: 'header',
      className: '',
      x: 0,
      y: -92,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Purchase successful!',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#00ff00',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {
        failed: {
          text: 'Purchase failed!',
          y: 0,
          style: {
            fill: '#ff0000'
          }
        }
      }
    },
    {
      id: '4f069140-5ace-4bc1-bc09-1afa8b9df1ae',
      type: 'Container',
      runtimeType: null,
      name: 'itemsContainer',
      className: '',
      x: 0,
      y: 12,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [
    'failed'
  ],
  animations: []
} as const;

export class PurchaseResultLayout {
  static raw = raw;
  root: Container;
  header: Text;
  itemsContainer: Container;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: 'failed';
    ModelByName: {
      root: typeof raw['list'][0];
      header: typeof raw['list'][2];
      itemsContainer: typeof raw['list'][3];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
